module.exports = __webpack_public_path__ + "img/b_Mukoleks_3.12ab43fc.jpeg";